import { useState, FC, FormEvent } from 'react';
import { useAsyncDebounce } from 'react-table';
import { SearchIcon } from '@chakra-ui/icons';
import { Button, FormControl, Input, InputGroup, InputRightElement } from '@chakra-ui/react';
import { useTranslation } from 'helpers/languages/translations';

const GlobalFilter: FC<{
    globalFilter: any;
    setGlobalFilter: (val: any) => void;
    submitSearch?: () => void;
    inputGroupStyles?: {
        [key: string]: string | number | boolean;
    };
}> = ({ globalFilter, setGlobalFilter, submitSearch, inputGroupStyles }) => {
    const [value, setValue] = useState(globalFilter);
    const onChange = useAsyncDebounce((val) => {
        setGlobalFilter(val || undefined);
    }, 200);
    const translate = useTranslation();

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (submitSearch) {
            submitSearch();
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <InputGroup size="sm" w="178px" mr="16px" {...inputGroupStyles}>
                <Input
                    onChange={(e) => {
                        setValue(e.target.value);
                        onChange(e.target.value);
                    }}
                    bg="white"
                    size="sm"
                    value={value || ''}
                    placeholder={translate('placeholder.search') as string}
                />
                {submitSearch ? (
                    <InputRightElement
                        cursor="pointer"
                        _hover={{ color: 'blue.500' }}
                        onClick={submitSearch}
                        children={<SearchIcon />}
                    />
                ) : (
                    <InputRightElement children={<SearchIcon />} />
                )}
            </InputGroup>
        </form>
    );
};

export default GlobalFilter;
